import DoctorSignature, { DoctorSignatureFooter, SIGNATURE_FOOTER_SPACE } from "./DoctorSignature";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { getAge } from "../utils/age";
import { drName } from "../redux/apiUrl";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#fff",
    paddingBottom: SIGNATURE_FOOTER_SPACE, // Último valor definido
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  logo: {
    width: "100%",
    height: "15%",
  },
  headerright: {
    width: "auto",
    height: "45%", // Último valor definido
  },
  headerright: {
    width: "auto",
    height: "45%", // Último valor definido
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 20,
  },
  subtitle: {
    textAlign: "left",
    fontSize: 14,
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 700,
    marginBottom: 5, // Reducido de 20 a 5 para disminuir el espacio
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 5,
  },
  bold: {
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 600,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.1,
    zIndex: "-10",
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
  },
  information_title: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    fontFamily: "Roboto",
    paddingTop: 10,
    paddingBottom: 10,
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row", // Mantener en fila inicialmente
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 5,
    fontFamily: "Roboto",
    maxHeight: 200, // Define una altura máxima después de la cual los elementos se ajustarán
  },
  gridItem: {
    width: "48%",
    marginBottom: 5,
    flexGrow: 1,
    breakInside: "avoid",
  },
  singleItem: {
    width: "100%",
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    paddingHorizontal: 30,
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 125,
  },
  twoColumnList: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 2, // Pequeño margen después del subtítulo
  },
  listItem: {
    width: "45%", // Mantiene dos columnas
    marginBottom: 2, // Espacio más pequeño entre elementos
    fontSize: 9, // Tamaño de fuente más pequeño
    fontFamily: "Roboto",
    color: "#000",
    paddingRight: 10, // Espacio entre columnas
  },
});

const HistoriaPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.watermark} src="/images/longLogo.png" />
        <Image style={styles.logo} src="/images/headerright.png" />

        {/* Title */}
        <Text style={styles.title}>Historia Clínica</Text>

        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>1. Filiación</Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Apellido y Nombre:</Text>{" "}
              {data?.patient?.persona?.apellidos +
                " " +
                data?.patient?.persona?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Fecha Nacimiento:</Text>{" "}
              {new Date(
                data?.patient?.persona.fecha_nacimiento
              ).toLocaleDateString("en-gb") ?? ""}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Edad:</Text>{" "}
              {getAge(new Date(data?.patient?.persona?.fecha_nacimiento)) ?? ""}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Sexo:</Text>{" "}
              {data?.patient?.persona?.sexo}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Residencia:</Text>
              {data?.patient?.persona?.residencia ?? ""}
            </Text>
          </View>
        </View>

        {/* Motivo de Consulta */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>2. Motivo de Consulta</Text>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.motivo?.replaceAll(",", ", ")}
            </Text>
          </View>
        </View>

        {/* Historia Actual */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>3. Historia Actual</Text>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.desglose_motivo}
            </Text>
          </View>
        </View>

        {/* Diagnostico */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>4. Diagnóstico</Text>
            <View style={styles.twoColumnList}>
              {data?.visita?.diagnostico
                ?.split("|")
                .join("\n")
                .split("\n")
                .filter((item) => item.trim().length > 0)
                .map((item, index) => (
                  <Text key={index} style={styles.listItem}>
                    • {item.trim().replaceAll(",", ", ")}
                  </Text>
                ))}
            </View>
          </View>
        </View>

        {/* Conducta */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>5. Conducta</Text>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.conducta
                ?.split("|")
                .join("\n")
                .split("\n")
                .filter((item) => item.trim().length > 0)
                .map((item, index) => (
                  <Text key={index} style={styles.listItem}>
                    • {item.trim().replaceAll(",", ", ")}
                  </Text>
                ))}
            </Text>
          </View>
        </View>

        {/* Comentarios */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.subtitle}>6. Comentarios</Text>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.comentarios ?? ""}
            </Text>
          </View>
        </View>

        <DoctorSignatureFooter>
          <DoctorSignature doctor={data?.doctor} />
          <View style={styles.colum}>
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>Entregue Conforme</Text>
          </View>
        </DoctorSignatureFooter>
        {/* Footer */}
        {/* <Image fixed style={styles.footerImage} src="/images/footerImage.png" /> */}
      </Page>
    </Document>
  );
};

export default HistoriaPdf;
